const API_BASE_URL = "https://hakimchat-worker.hakimhakim.workers.dev";

export default API_BASE_URL;